import { BCMSDefaultModel, BCMSRecord, StateManager, useBCMSContext, useRoute, useStateManager, useWorkflow } from "@bcm-dev/bcms-vite";
import { UIPrimaryButton } from 'components/ui/UIButton';
import Classes from "model";
import React from 'react';
import { ImageAsset, SVGAsset } from 'res';
import VerificationProgressWidget from '../widgets/VerificationProgressWidget';
import "./styles.css";

/**
 * @function VerificationSuccessView
 * @return {React.Component}
 * @exported true
 * @description The view that shows after the verification is successful
 */

export default function VerificationSuccessView(props){
  const bcmsContext = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, bcmsContext);
  // Get the card id from the parameter
  const data = { ...getDefaultData(), ...props.data ?? {} };
  const ui = { ...getDefaultUI(), ...props.ui ?? {} };
  const { goStep, nextStep } = useWorkflow() ?? {};
  const navigate = useRoute();

  const controller = (state, setState) => ({
    data: state.data,
    ui: state.ui,

    next: () => {
      if(goStep) {
        // Reset the data used in the workflow.
        BCMSRecord.globalControllerFor(Classes, bcmsContext);
        data.cardOnFileMerchant = BCMSDefaultModel.cardOnFileMerchant();
        goStep(0, { data, ui });
      } else {
        navigate("/home/cardonfile/cardonfile");
      }
    }
  });

  return (
    <StateManager state={ { data, ui } } controller={ controller }>
      <PageContent/>
    </StateManager>
  );
}

export const getDefaultData = () => {
  const cardOnFileMerchant = BCMSDefaultModel.cardOnFileMerchant();

  return {
    cardOnFileMerchant,
    revealPassword: false
  }
}

export const getDefaultUI = () => ({

});

function PageContent(props) {
  const { data, ui, next } = useStateManager();
  const { goStep } = useWorkflow() ?? {};
  const navigate = useRoute();
  const merchant = data.cardOnFileMerchant.merchant ?? {};
  const merchantName = props.merchantName ?? "[[MerchantName]]";
  const merchantLogo = props.merchantLogo ?? <><ImageAsset id={ merchant.logo } className="transaction-logo" /></>;

  return (
    <div className="verification-success-view verification-view">
      <VerificationProgressWidget className="complete" />
      <p>Update Completed</p>
      <div className="account-container">
        <div className="header-container flex-container flex-horizontal align-center-container bottom-border">
          <div className="set-width img-container">
            { merchantLogo }
          </div>
          <p className="flex-width">{ merchant.name }</p>
        </div>
        <div className="flex-container flex-vertical all-center-container success-container">
          <div className="flex-container flex-horizontal all-center-container success-message">
            <SVGAsset id="CheckmarkIcon" className="icon set-width checkmark-icon left-inline-icon green-icon" />
            <p>Your card was placed successfully.</p>
          </div>
          <UIPrimaryButton text="Done" onClick={ next } />
        </div>
      </div>
    </div>
  );
}